import React from 'react'
import ReactDOM from 'react-dom'
import MainComponent from './mainComponent'
import * as serviceWorker from './serviceWorker'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import store from './redux/store'
import './bootstrap/bootstrap.min.css'
import './style.css'
ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <MainComponent />
    </BrowserRouter>
  </Provider>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
